import React from 'react'
import { LanguageProvider, useLang } from './i18n/LanguageContext'
import Navbar from './components/Navbar/Navbar'
import HeroSection from './components/HeroSection/HeroSection'
import AboutSection from './components/AboutSection/AboutSection'
import HistorySection from './components/HistorySection/HistorySection'
import SolutionsSection from './components/SolutionsSection/SolutionsSection'
import ElosSpotlight from './components/ElosSpotlight/ElosSpotlight'
import StatsSection from './components/StatsSection/StatsSection'
import BenefitsSection from './components/BenefitsSection/BenefitsSection'
import ClientsSection from './components/ClientsSection/ClientsSection'
import ContactSection from './components/ContactSection/ContactSection'
import Footer from './components/Footer/Footer'
import ChatBot from './components/ChatBot/ChatBot'

function Site() {
  const { lang, T } = useLang()
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <SolutionsSection />
        <ElosSpotlight />
        <StatsSection />
        <HistorySection />
        <BenefitsSection />
        <ClientsSection />
        <ContactSection />
      </main>
      <Footer />
      <ChatBot
        greeting={T.chatbot.greeting}
        title={T.chatbot.title}
        fabLabel={T.chatbot.fab}
        lang={lang}
      />
    </>
  )
}

export default function App() {
  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  )
}
